<!-- Экран трансляции на пробный урок-->
<template>
    <div class="">
        <div class="white_container reserved_container">
            <div class="reserved-container" v-if="isTrialSoonLesson==false">
                <h2>{{$t("lesson.LBL_TEST_SCHEDULED")}}</h2>
                <div class="lesson-details">
                    <div class="details-day" style="text-transform: capitalize;">{{$t("strings."+selected_day)}}</div>
                    <div class="details-day" style="text-transform: capitalize;">{{trial.date}} {{$t("strings.MONTH_"+parseInt(trial.mon))}}</div>
                    <div class="details-day">{{textTime}}</div>
                </div>
                <div class="lesson-buttons">
                    <button class="button button-secondary" @click="cancelLesson"><span>{{$t("lesson.BTN_REPLACE_LESSON")}}</span></button>
                </div>
            </div>
            <div class="reserved-container" v-if="isTrialSoonLesson==true">
                <h2>{{$t("lesson.LBL_TRIAL_SCHEDULED_SOON")}}</h2>
                <div class="lesson-image">
                    <img src="@/assets/img/start-up1.png" />
                </div>
                <div class="lesson-timer">
                    <Countdown class="small" :display_days="false" :display_hours="false" :date="new Date(trial.datetime)" v-on:onTick="onTick"></Countdown>
                </div>
                <div class="lesson-buttons">
                    <a :href="trial.link" target="_blank" class="button with_icon">
                        <i class="icon-play-circle"></i><span>{{$t("lesson.BTN_START_TRIAL_TRANSLATION")}}</span>
                    </a>
                </div>
            </div> 
        </div>
        <TechCheckPassedFailPopup
            :show="showTechCheckPassedFailPopup"
            :date="trial.datetime"
            :time="textTime"
            v-on:closeEvent="techCheckPassedFailPopupCloseEvent">
        </TechCheckPassedFailPopup>
        <TehBookingNoVisitPopup
            :show="showTehBookingNoVisitPopup"
            :date="trial.datetime"
            :time="textTime"
            v-on:closeEvent="TehBookingNoVisitPopupCloseEvent">
        </TehBookingNoVisitPopup>
        <div class="white_container">
            <div class="prepare-container-wrapper">
                <h2>Cum ne pregătim</h2>
                <div class="prepare-info">
                    <div class="cell">
                        <img src="@/assets/img/pencil.png" alt="#" class="pencil">
                        <div>
                            <h2 class="cell-title">Rețineți data lecției</h2>
                            <p>Verificați dacă veți putea fi prezent cu <br>copilul la ora indicată. Fixați data în <br>calendar.</p>
                        </div>
                    </div>
                    <div class="cell">
                        <img src="@/assets/img/clock.png" alt="#" class="pencil">
                        <div>
                            <h2 class="cell-title">Vă sunăm prealabil</h2>
                            <p>Cu 10 minute înainte vom confirma că<br>părintele va fi prezent la lecție. Aceasta<br>este cerința legii.</p>
                        </div>
                    </div>
                    <div class="cell">
                        <img src="@/assets/img/webcam.png" alt="#" class="pencil">
                        <div>
                            <h2 class="cell-title">Verificați echipamentul</h2>
                            <p>Este nevoie de web cameră, microfon și<br>căști la calculator sau laptop.<br>Instalați Zoom accesând următorul link.</p>
                        </div>
                    </div>
                    <div class="cell">
                        <img src="@/assets/img/lectie.png" alt="#" class="pencil">
                        <div>
                            <h2 class="cell-title">Accesăm lecția</h2>
                            <p>Accesați de sinestătător butonul Start<br>apel, Vă acomodați, iar metodistul se<br>va alătura.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters, mapActions } from 'vuex';
    import env from '@/enviroment';
    import lStorage from '@/store/localStorage';
    import store from '@/store';
    import Countdown from '../../Countdown';
    import { dateConvert, dateConvertToNumber, isSoonDate } from '../../../../../utils/utils';
    import TechCheckPassedFailPopup from './TechCheckPassedFailPopup';
    import TehBookingNoVisitPopup from './TehBookingNoVisitPopup';
    import {rest} from "@/utils/utils";

    export default {
        name: "TechCheckPassedStep",
        components: {
            Countdown,
            TechCheckPassedFailPopup,
            TehBookingNoVisitPopup
        },
        data: function () {
            return {
                loaded: false,
                isSoonLesson: -1,
                showTechCheckPassedFailPopup: false,
                showTehBookingNoVisitPopup: false,
                lastupdate:null,
                trial:{
                    datetime:""
                },
                trialTick:null,
                isTrialSoonLesson:false
            }
        },
        computed: {
            textTime() {
                if (this.trial.datetime !== null && this.trial.datetime !== '') {
                    return this.trial.datetime.split(' ')[1];
                }
                return '';
            },
            selected_day(){
                if(this.trial){
                    if(typeof this.trial.day != "undefined"){
                        switch(this.trial.day){
                            case "0":
                                return "WK_SUN";
                            break;
                            case "1":
                                return "WK_MON";
                            break;
                            case "2":
                                return "WK_TUE";
                            break;
                            case "3":
                                return "WK_WED";
                            break;
                            case "4":
                                return "WK_THU";
                            break;
                            case "5":
                                return "WK_FRI";
                            break;
                            case "6":
                                return "WK_SAT";
                            break;
                        }
                    }
                }
                return "";
            },
        },
        mounted(){
            store.commit('loading/is',true);
            rest.call("lead_status",{},"GET").then((response)=>{
                store.commit('loading/is',false);
                if(response.data.trial) this.trial = response.data.trial;
                this.trialTickOut();
                this.trialTick = window.setInterval(this.trialTickOut,1000*60);
            }).catch((error)=>{
                store.commit('loading/is', false);
            });
        },
        methods: {
            onTick(time) {
                if ((time - 10 * 60) <= 0) {
                    this.isSoonLesson = 1
                } else {
                    this.isSoonLesson = 0
                }

                if (time <= 0) {
                    this.startCheckingStatus();
                }
            },
            startCheckingStatus() {
                //Будем проверять каждую минуту (60 секунд)
                if(!this.lastupdate || (Math.floor(Date.now() / 1000) - this.lastupdate > 60)){
                    this.lastupdate = Math.floor(Date.now() / 1000);

                    store.commit('loading/is',true);
                    rest.call("lesson_status",{
                        "lesson_id":null,
                        "type":"trial",
                    }).then((response)=>{
                        store.commit('loading/is',false);
                        this.lastupdate = Math.floor(Date.now() / 1000);
                        if(response.lesson){
                            this.showTechCheckPassedFailPopup = response.lesson.status === 'fail';
                            this.showTehBookingNoVisitPopup = response.lesson.status === 'no-visit';
                            if(response.lesson.status === 'ok'){
                                store.dispatch('user/updateProfile');
                                store.commit('trialBookingFlow/currentStep', 'test-passed');
                            }
                        }
                    }).catch((error)=>{
                        store.commit('loading/is',false);
                    });
                }
            },
            changeAnyDate() {
                store.commit('user/is_planned', 0);
            },
            techCheckPassedFailPopupCloseEvent() {
                store.dispatch('trialBookingFlow/getHomeInfo');
                this.showTechCheckPassedFailPopup = !this.showTechCheckPassedFailPopup;
                store.commit('trialBookingFlow/currentStep', 'test-new');
            },
            TehBookingNoVisitPopupCloseEvent() {
                store.dispatch('trialBookingFlow/getHomeInfo');
                this.showTehBookingNoVisitPopup = !this.showTehBookingNoVisitPopup;
                store.commit('trialBookingFlow/currentStep', 'test-new');
            },
            
            getDiffInSeconds(date){
                let now = new Date();
                let datet = new Date(date);
                let diff = datet - now;
                return Math.round(diff / 1000); // преобразуем в секунды
            },
            trialTickOut(){
                if(typeof this.trial.datetime != "undefined" && this.trial.datetime !== null && this.trial.datetime !== '') {
                    var d = this.getDiffInSeconds(new Date(this.trial.datetime));
                    if(d <= 900){
                        this.isTrialSoonLesson = true;
                        window.clearInterval(this.trialTick);
                        return true;
                    }
                }
                this.isTrialSoonLesson = false;
            },
            cancelLesson(){
                store.commit('loading/is',true);
                rest.call("disable_lesson",{
                    "lesson_id":this.trial.id,
                    "type":"trial",
                }).then((response)=>{
                    store.commit('loading/is',false);
                    if(response.status == "ok"){
                        store.commit('trialBookingFlow/currentStep', 'test-new');
                    }
                }).catch((error)=>{
                    store.commit('loading/is',false);
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .button {
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        margin-bottom: 6.2rem;
    }
    .button_not_active {
        background: #F0F3F8;
        span{
            color: #0B1022;
        }
        box-shadow: inherit !important;
        cursor: auto;
    }
    .button-secondary {
        background: #F0F3F8;
        span{
            color: #0B1022;
        }
    }

    .timer {
        margin-top: 10.5rem;
    }

    .reserved_container {
        text-align: center;
        padding: 6rem 1.5rem 4rem;
    }
    .lesson-details{
        border: 1px solid #F0F3F8;
        border-radius: 10px;    
        display: grid;
        grid-template-columns: repeat(3,1fr);    
        margin: 40px auto 0px;
        max-width: 600px;
        .details-day{
            text-align: center;
            font-family: FuturaPT;
            font-size: 24px;
            letter-spacing: 1.3px;
            color: #0B1022;
            font-weight: bold;
            padding: 30px 0px;
            border-right: 1px solid #F0F3F8;
        }
    }
    .start_container_text{
        margin:27px 0px 0px;
    }
    .lesson-buttons{
        margin-top:24px;
        >*{
            margin-right: 10px;
            *:last-child{
                margin-right: 0px;
            }
        }
    }
    .lesson-image{
        display: flex;
        align-items: center;
        justify-content: center;
        margin:3rem;
        >img{

        }
    }
    .timer_container.small{
        margin: 2rem 0rem 4rem;
    }
    .prepare-container-wrapper{
        padding: 30px 44px;
        h2{
            text-align: center;
        }
        .prepare-info{
            display: grid;
            grid-template-columns: repeat(2,1fr);
            grid-gap:2rem;
            margin: 4rem;
            >.cell{
                border: 1px solid #F0F3F8;
                border-radius: 10px;
                display: flex;
                flex-direction: row;
                img{

                }
                &>div{
                    padding: 2rem;
                    >h2{
                        font-size: 24px;
                        text-align: left;
                    }
                    >p{
                        color:#565758;
                    }
                }
            }
        }
    }
</style>